import { render } from "./ContainerTrainingAgreementForm.vue?vue&type=template&id=205d8cf6"
import script from "./ContainerTrainingAgreementForm.vue?vue&type=script&lang=js"
export * from "./ContainerTrainingAgreementForm.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "../i18n/ContainerTrainingAgreementForm.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Fpeeristics%2Frails-frontend%2Fapp%2Fassets%2Fvue%2Fcontainers%2Fadmin%2Fcomponents%2FContainerTrainingAgreementForm.vue&lang=yml&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__